import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
@BindAll()
export class LegalScreenController {
  Model = new BaseModel({ type: 'object' });

  // 是否弹出法务弹窗
  async getShowLegalScreen() {
    return await AjaxBasics.request({
      ...EnumAPI.idass_get_protect_legalScreen,
    });
  }

  // 记录法务弹窗确认时间
  async submitLegalScreen() {
    return await AjaxBasics.request({
      ...EnumAPI.idass_save_protect_legalScreen,
    });
  }
}
